<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big">ISLAND</span><br/><br/></p>
<p class="center"><span class="big1"><em>Charles Abbott</em></span><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780062029300_logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062029300_epub_tp_r1.vue?a169fc34